import React from 'react';
import ReactMarkdown from 'react-markdown';

import { AiAssistantDisclaimerKey, aiAssistantDisclaimers } from './ai-assistant-disclaimers';

type Props = {
  assistant: AiAssistantDisclaimerKey;
  className?: string;
};

export const AiAssistantDisclaimer = ({ assistant, className }: Props) => {
  const disclaimer = aiAssistantDisclaimers[assistant];
  if (!disclaimer) {
    return null;
  }

  return (
    <div
      className={`mt-5 rounded-control bg-surface-muted p-4 text-ui-xs lg:text-ui text-ink-muted leading-relaxed ${
        className ?? ''
      }`}
    >
      <ReactMarkdown
        components={{
          p: (paragraphProps) => <p className="mt-3 mb-1 last:mb-0" {...paragraphProps} />,
        }}
      >
        {disclaimer}
      </ReactMarkdown>
    </div>
  );
};
